/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ShowManagementListShowRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: ShowManagementListShowRequest.direction | null;
    titles?: string | null;
    counts?: string | null;
};

export namespace ShowManagementListShowRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

